// The signed-in account (GET /me), without Solid so routing code and tests can await it.
import type { Me } from "../../shared/api";
import { ApiFailure, api } from "../api";

let latest: Promise<Me | null> = new Promise(() => undefined); // until the first load starts

/** Loads the account: null when signed out (401); other failures reject. */
export function loadMe(): Promise<Me | null> {
  latest = api.get<Me>("/me").catch((e: unknown) => {
    if (e instanceof ApiFailure && e.status === 401) return null;
    throw e;
  });
  return latest;
}

/** After sign-out: known as signed out without a new request. */
export function forgetMe(): void {
  latest = Promise.resolve(null);
}

/** The account once the latest load settles; a failed load counts as signed out. */
export const knownMe = (): Promise<Me | null> => latest.catch(() => null);
